<!--
 * @Description: 视频块组件
 * @Author: 房旭
 * @LastEditors: 房旭
 * @Date: 2019-02-26 15:09:34
 * @LastEditTime: 2019-04-03 14:55:33
 -->
<template>
  <div>
    <div>
      <div class="demo-upload-list">
        <!-- <img src="/assets/images/video.svg"> -->
        <div class="demo-upload-list-cover">
          <div class="demo-upload-list-cover">
            <Icon type="ios-play" @click.native="showVideo()"></Icon>
            <Icon type="ios-trash-outline" @click.native="delVideo()" v-if="delBtn"></Icon>
          </div>
          <video style="width:60px;height:60px;object-fit:cover" :src="videosrc"></video>
        </div>
      </div>
    </div>
    <Modal title="视频播放" v-model="visible" @on-ok="modalOk" @on-cancel="modalCancel">
      <video-player class="vjs-custom-skin" ref="videoPlayer" :options="options" :playsinline="true"></video-player>
    </Modal>
  </div>
</template>

<script>
  import 'video.js/dist/video-js.css'
  import {
    videoPlayer
  } from 'vue-video-player'
  export default {
    props: {
      videosrc: {//视频路径
        type: String
      },
      delBtn: {//是否显示删除按钮
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        visible: false,//弹出层
        host:'',//主机
        options: {//属性
          muted: false,
          autoplay: false,//自动播放
          width: "490",//宽度
          sources: [{//视频内容
            src: ''
          }]
        }
      };
    },
    components: {
      videoPlayer
    },
    computed: {
      player() {
        return this.$refs.videoPlayer.player
      }
    },
    methods: {
      showVideo() { //缩略图播放按钮显示
        this.visible = true;
        this.$refs.videoPlayer.player.play();
      },
      delVideo() { //缩略图删除视频按钮
        this.$emit("on-delete");
      },
      modalOk() { //点击确定按钮暂停视频，关闭对话框
        this.visible = false;
        this.$refs.videoPlayer.player.pause();
      },
      modalCancel() { //点击取消按钮暂停视频，关闭对话框
        this.visible = false;
        this.$refs.videoPlayer.player.pause();
      }
    },
    mounted () {
      this.options.sources[0].src = this.host + this.videosrc;
    }
  };

</script>

<style scoped>
  .demo-upload-list {
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    margin-right: 4px;
  }

  .demo-upload-list img {
    width: 100%;
    height: 100%;
  }

  .demo-upload-list-cover {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    right: 0;
    background: rgba(0, 0, 0, 0.3);
  }
  .demo-upload-list-cover>.demo-upload-list-cover{
    background: rgba(0, 0, 0, 0) !important;
  }
  /*.demo-upload-list:hover .demo-upload-list-cover {*/
  /*display: block;*/
  /*}*/

  .demo-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
   
  }

</style>
